import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Akcoat',
  logo: { name: 'Akcoat', src: '/logo/akcoatcard.png' },
  portrait: { src: '/photo/portrait-veysi-kucuk.png', alt: 'Veysi Küçük' },
  quote: [
    'Thanks to the digital transformation solution, Akcoat has clarified some fuzzy concepts '
    + 'from its own perspective. One of the most important points in Akcoat’s digital '
    + 'maturity level measurement was the awareness of all leaders about their strengths and '
    + 'development areas with great sincerity and openness. By cultivating a brainstorming '
    + 'environment with the participation of colleagues from all departments, our awareness '
    + 'of digital transformation was maximized. Akcoat determined its digital maturity level '
    + 'objectively by scoring the company thanks to the excellent support and methodology '
    + 'Digitopia provided to Akcoat.',
  ],
  attribution: 'Veysi Küçük, General Manager',
  story: 'akcoat',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 10
